module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAMAAACO0hVbAAAAAXNSR0IB2cksfwAAADZQTFRFAAAAaWlwaGhxaGhwaGhyaGhwaWlxaGhwZ2dxaGhxaGhxaGhyaGhwampwZ2dwaGhxaGhxaGhx+e0DAwAAABJ0Uk5TAFC/IIBAP59v4MBgfzCP0JCwVA6aNgAAAFdJREFUeJydztEKgCAMheGTzpVL097/ZQtFpRURfVeHHwYDTpNpLBpy1+GYeV64KsPCkyYQaO9tDbE3H4pNYqorCJKrqK9xS32Nlp/aHm/t639/mjdaPgAALgPakV0VZQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/temp/ico-briefcase-inactive.png
// module id = 752
// module chunks = 1